import { useContext } from "react";
import AuthContext from "../../globalState/context/AuthProvider";

const useAuth = () => {
	return useContext(AuthContext);
};

export default useAuth;
